import React from 'react';
import { StyleProp, TouchableOpacity } from 'react-native';

import { StyleObj } from '@providers/Theme/types';
import { makeStyles } from '@providers/Theme';

type CardProps = {
  children: React.ReactNode;
  style?: StyleProp<StyleObj>;
  onPress?: () => void;
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    padding: 0,
    backgroundColor: 'white',
    boxShadow: 'rgb(188 188 188 / 39%) 0px 8px 10px 2px', // TODO: introduce shadow presets
    elevation: 8,
  },
}));

export const Card: React.FC<CardProps> = ({ children, style, onPress }) => {
  const styles = useStyles();

  return (
    <TouchableOpacity onPress={onPress} style={[styles.root, style]}>
      {children}
    </TouchableOpacity>
  );
};
